(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './react-swipe'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./react-swipe'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reactSwipe);
    global.index = mod.exports;
  }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-easy-swipe/lib/index.js
// module id = 1914
// module chunks = 35783957827783